import { Container, Button,Alert, Modal, Col, Row , Form} from 'react-bootstrap';
import {Sida,Rubrik,ContentWrapper} from "../ContentStyles";
import useBackend, {CallAPI, Loading, IsLoggedIn, Check} from '../../services/useBackend_v2';
import React, {useMemo, useState } from 'react';
import MaterialReactTable from 'material-react-table';
import {Branding, DateTimeToLocal} from '../../services/misc';

export default function IOTCore() {
    const { loading, data, Refresh, resultSuccess, resultVariant, resultVisible, resultText, Update, XCall } =  useBackend('/api/iotcore');

    var {loggedIn, isAdmin, isSuperUser, userName, accountIsLocked} = IsLoggedIn();

    const [modalshow,  setModalshow] = useState(false);    
    const initModal = () => { return setModalshow(!modalshow) }    

    const [selectedShopData, setSelectedShopData]   = useState({Name:"...", OpeningHoursUTCStart:"00:00:00", OpeningHoursUTCEnd:"00:00:00", EntryCode:{Code:""}, IOTConnection: {Online:false, Temp : 0} , DeviceType: { DeviceCommands: []} });

    const [pagination, setPagination] = useState({ pageIndex: 0, pageSize: 25 });

    var typingTimeout = null;

    function handleChange(event){
	    clearTimeout(typingTimeout);
	    typingTimeout = setTimeout(handleSave, 475);        
    }

    function handleSave(){
        var v = document.getElementById('Description');
        var formDataObj = { Description: v.value};
        CallAPI('/api/iotcore/'+selectedShopData.Guid,"PATCH",JSON.stringify(formDataObj));
        Refresh();
    }

    const detailShopClick = async (event, rowData)  =>  {
        setSelectedShopData(rowData.original)
        setModalshow(!modalshow);        
    }
    
    const columns = useMemo(() => [
        { size: 100, accessorKey: 'Description', header: 'Description' },
        { size: 100, accessorKey: 'ChipID', header: 'ChipID' },
        { size: 100, accessorKey: 'IOTConnection.Reconnections', header: 'Reconnections' },
        { size: 100, accessorKey: 'IOTConnection.RSSI',     header: 'RSSI' },                    
        {
            size: 20, header: 'Online', enableOrdering: true, enableColumnOrdering: true, enablePinning: true, enableColumnActions: true,
            Cell: ({ row }) => (<Check checked={row.original.IOTConnection.Online} />),
        },             
      ]
    );  

    const initialState = 
    { 
        density: 'compact',
        columnVisibility: { Company: false, Description:true }, 
        pagination : pagination 
    };  

    const state = { pagination : pagination };      

    async function sendCommand(event){
        const command = event.currentTarget.getAttribute("command");
        await XCall('/api/iotcore/'+selectedShopData.Guid+'/command',"PUT", 3000, { command: command });
    }

    if (!loading && resultSuccess) {
        return (
            <ContentWrapper>
                <Modal show={modalshow} onHide={initModal}>
                    <Modal.Header closeButton>
                        <Modal.Title>{selectedShopData.Description} ({selectedShopData.ChipID})</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Form.Group className="mb-3" >
                                <Form.Label>Description</Form.Label>
                                <Form.Control type="text" name="Description" id="Description" placeholder="Description" defaultValue={selectedShopData.Description} onChange={handleChange} />
                            </Form.Group>                    
                        </Row>
                        <Row>
                            <Col>ChipID</Col><Col>{selectedShopData.ChipID}</Col>                        
                        </Row>

                        <Row>
                            <Col>DeviceType</Col><Col>{selectedShopData.DeviceType.Description}</Col>                        
                        </Row>

                        <Row>
                            {/* SplitoutLocalTimeFromISO( */}
                            <Col>LastHeartbeat</Col><Col>{DateTimeToLocal(selectedShopData.IOTConnection.LastHeartbeat)}</Col>                        
                        </Row>

                        <Row>
                            <Col>SSID</Col><Col>{selectedShopData.SSID}</Col>                        
                        </Row>
                        <Row>
                            <Col>IPAddr</Col><Col>{selectedShopData.IPAddr}</Col>                        
                        </Row>                        

                        <Row>
                            <Col>Online</Col><Col><Check checked={selectedShopData.IOTConnection.Online} /></Col>                        
                        </Row>

                        <Row>
                            <Col>Temperatur</Col><Col>{selectedShopData.IOTConnection.Temp}</Col>                        
                        </Row>

                        <Row>
                            <Col>RSSI</Col><Col>{selectedShopData.IOTConnection.RSSI}</Col>                        
                        </Row>

                        <div style={{marginTop:'12px'}}>
                            <Alert show={resultVisible} variant={resultVariant}  className="FormSpace">{resultText}</Alert>
                        </div>
                  </Modal.Body>
                  <Modal.Footer>
                    {selectedShopData.DeviceType.DeviceCommands.map((item) => {
                        return <div><Button variant="primary" type="button" style={{backgroundColor:Branding().ButtonColor}} disabled={!selectedShopData.IOTConnection.Online} command={item.Command} onClick={sendCommand}>{item.Name}</Button>&nbsp;</div>
                    })}
                  </Modal.Footer>
                </Modal>

                <Container>
                    <Sida>                    
                        <MaterialReactTable  columns={columns} data={data.Devices} 
                            muiTablePaginationProps={{ showFirstButton: false, showLastButton: false ,labelRowsPerPage:"Rader", rowsPerPageOptions: [25, 50, 100]}}
                            renderTopToolbarCustomActions={() => (<Rubrik>Uppkopplade Enheter</Rubrik>)} initialState={initialState} onPaginationChange={setPagination} state={state} 
                                muiTablePaperProps={{elevation: 0, sx: {borderRadius: '0',border: '0px dashed #e0e0e0'} }} 
                                
                                muiTableBodyRowProps={({ row }) => ({
                                    onClick: (event) => {
                                        detailShopClick(event, row);
                                    },
                                    sx: {
                                    cursor: 'pointer', //you might want to change the cursor too when adding an onClick
                                    },
                                })}
                        />                                            
                    </Sida>
                </Container>
            </ContentWrapper>            
        );
    } else {
        return (<Loading />);         
    }
}